"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _generateUuid = _interopRequireDefault(require("../../utils/generate-uuid"));

var _Render = _interopRequireDefault(require("./Render"));

var _Form = _interopRequireDefault(require("./Form"));

var _ = require("../../");

var defaultAttrs = function defaultAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _.Tools.applyDefaults({
    width: "100%",
    height: "",
    borderSize: 0,
    borderColor: "#000000",
    backgroundColor: "transparent",
    backgroundImage: "",
    backgroundSize: "",
    upload: "",
    direction: "vertical",
    alignment: "",
    paddingTop: 8,
    paddingRight: 8,
    paddingBottom: 8,
    paddingLeft: 8,
    allowChildren: false
  }, attrs);
};

var _default = {
  Render: _Render["default"],
  Form: _Form["default"],
  type: "Row",
  label: "Row",
  // cannot be called single column row because all multi-column rows become a Row after component selection
  description: "The row component allows you to group multiple components together. It can be used for vertically stacking components or positioning multiple components next to each other.",
  defaultAttrs: defaultAttrs,
  generateContent: function generateContent() {
    return [{
      id: (0, _generateUuid["default"])(),
      type: "Row",
      content: [{
        id: (0, _generateUuid["default"])(),
        type: "Row",
        content: [],
        attrs: defaultAttrs({
          width: "100%",
          allowChildren: true
        })
      }],
      attrs: defaultAttrs({
        direction: "horizontal",
        allowChildren: false
      })
    }];
  }
};
exports["default"] = _default;